package login

import com.tryformation.localization.Translatable
import dev.fritz2.core.RootStore
import dev.fritz2.core.Store
import koin.koinCtx
import koin.withKoin
import kotlinx.coroutines.Job
import localization.translate
import routing.MainController
import theme.FormationIcons
import twcomponents.twColOfNoGap
import twcomponents.twMainTitle
import twcomponents.twModal
import twcomponents.twModalContentWrapper
import twcomponents.twRowOfJustifyBetween
import utils.ToggleStore

data class WorkSpaceChange(
    val oldRoute: Map<String, String>,
    val oldWorkspace: String?,
    val newRoute: Map<String, String>,
    val newWorkspace: String
)

class ChangeWorkspaceToggleStore : ToggleStore(false)

enum class ChangeWorkspaceModal : Translatable {
    TITLE,
    INFO,
    QUESTION,
    STAY_IN,
    LOGIN_TO
    ;

    override val prefix = "changeworkspacemodal"
}

class ChangeWorkspaceStore : RootStore<WorkSpaceChange?>(
    initialData = null,
    job = Job(),
) {

    val reset = handle { null }

    fun changeWorkspacePopup(oldRoute: Map<String, String>, oldWS: String?, newRoute: Map<String, String>, newWS: String) {
        withKoin {
            val changeWorkspaceToggleStore: ChangeWorkspaceToggleStore = get()

            if (oldWS != null && oldWS != current?.oldWorkspace) {
                console.log("New workspace detected:", newWS)
                update(
                    WorkSpaceChange(
                        oldRoute = oldRoute,
                        oldWorkspace = oldWS,
                        newRoute = newRoute,
                        newWorkspace = newWS,
                    ),
                )
                changeWorkspaceToggleStore.update(true)
            }
        }
    }
}


fun changeWorkspacePopupModal(toggleStore: Store<Boolean>) {
    val changeWorkspaceStore: ChangeWorkspaceStore by koinCtx.inject()
    val mainController: MainController by koinCtx.inject()

    twModal(
        toggleStore,
    ) { close, _, _ ->
        twModalContentWrapper("w-100 gap-8 p-4") {
            twMainTitle(icon = FormationIcons.Map) {
                translate(ChangeWorkspaceModal.TITLE)
            }

            changeWorkspaceStore.data.render { wsData ->

                p("text-center text-sm font-light") {
                    translate(
                        ChangeWorkspaceModal.INFO,
                        listOfNotNull(
                            wsData?.newWorkspace?.let { "newWorkspace" to it },
                            wsData?.oldWorkspace?.let { "oldWorkspace" to it },
                        ).toMap(),
                    )
                }

                p("text-center font-bold") { translate(ChangeWorkspaceModal.QUESTION) }

                twRowOfJustifyBetween("w-full") {
                    twColOfNoGap("items-center justify-center p-2.5 gap-3 rounded-xl cursor-pointer text-gray-700 hover:bg-gray-100") {
                        p(" text-center text-xs") {
                            translate(ChangeWorkspaceModal.STAY_IN)
                        }
                        p("text-center") {
                            +"${wsData?.oldWorkspace}"
                        }

                        clicks handledBy {
                            // update route with old workspace
                            close(Unit)
                            mainController.stayInWorkspace(Unit)
                            changeWorkspaceStore.reset(Unit)
                        }
                    }
                    twColOfNoGap("items-center justify-center p-2 gap-3 rounded-xl cursor-pointer bg-green-50 text-green-700 hover:bg-green-100") {
                        p(" text-center text-xs font-bold") {
                            translate(ChangeWorkspaceModal.LOGIN_TO)
                        }
                        p("text-center font-bold") {
                            +"${wsData?.newWorkspace}"
                        }

                        clicks handledBy {
                            close(Unit)
                            mainController.changeWorkspace(Unit)
                        }
                    }
                }
            }
        }
    }
}
